import React from "react";
const CircleCorner = ({ size = 100, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill={color}
  >
    <path d="M100 0c0 55.228475-44.771525 100-100 100V0z" />
  </svg>
);
export default CircleCorner;
